import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-63bdabd8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bar" };
const _hoisted_2 = { class: "barbox" };
const _hoisted_3 = {
    class: "clearfix",
    id: "line1"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", {
    class: "pulll_left counter",
    id: "totalbookscount"
}, null, -1));
const _hoisted_5 = {
    class: "pulll_left counter",
    id: "totalReader"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", {
    class: "pulll_left counter",
    id: "30daysborrowedcount"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", {
    class: "pulll_left counter",
    id: "todayborrowedcount"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/ _createStaticVNode("<div class=\"barbox2\" data-v-63bdabd8><ul class=\"clearfix\" data-v-63bdabd8><li class=\"pulll_left\" data-v-63bdabd8>馆藏总量</li><li class=\"pulll_left\" data-v-63bdabd8>读者总数</li><li class=\"pulll_left\" data-v-63bdabd8>上月借阅次数</li><li class=\"pulll_left\" data-v-63bdabd8>今日借阅次数</li></ul></div>", 1);
const _hoisted_9 = { class: "bar" };
const _hoisted_10 = { class: "barbox" };
const _hoisted_11 = {
    class: "clearfix",
    id: "line2"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", {
    class: "pulll_left counter",
    id: "totalborrowedcount"
}, null, -1));
const _hoisted_13 = {
    class: "pulll_left counter",
    id: "avgBook"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", {
    class: "pulll_left counter",
    id: "30daysreturncount"
}, null, -1));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", {
    class: "pulll_left counter",
    id: "todayreturncount"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/ _createStaticVNode("<div class=\"barbox2\" data-v-63bdabd8><ul class=\"clearfix\" data-v-63bdabd8><li class=\"pulll_left\" data-v-63bdabd8>累计借阅</li><li class=\"pulll_left\" data-v-63bdabd8>人均借阅量</li><li class=\"pulll_left\" data-v-63bdabd8>上月归还次数</li><li class=\"pulll_left\" data-v-63bdabd8>今日归还次数</li></ul></div>", 1);
const _hoisted_17 = /*#__PURE__*/ _createStaticVNode("<div style=\"height:0.125rem;\" data-v-63bdabd8></div><div class=\"map\" data-v-63bdabd8><div class=\"map1\" data-v-63bdabd8><img src=\"/assets/common/image/lbx.png\" data-v-63bdabd8></div><div class=\"map2\" data-v-63bdabd8><img src=\"/assets/common/image/jt.png\" data-v-63bdabd8></div><div class=\"boxall\" style=\"height:3rem;\" data-v-63bdabd8><div class=\"alltitle\" data-v-63bdabd8>馆藏变化</div><div style=\"width:100%;height:calc(100% - 20px);position:relative;\" data-v-63bdabd8><div class=\"allnav\" id=\"echart6\" style=\"width:100%;height:100%;\" data-v-63bdabd8></div></div><div class=\"boxfoot\" data-v-63bdabd8></div></div><div class=\"boxall\" style=\"height:3.5rem;\" data-v-63bdabd8><div class=\"alltitle\" data-v-63bdabd8>借还趋势</div><div style=\"width:100%;height:100%;\" data-v-63bdabd8><div class=\"allnav\" id=\"echart4\" data-v-63bdabd8></div></div><div class=\"boxfoot\" data-v-63bdabd8></div></div></div>", 2);
import { onMounted, onUnmounted, ref } from "vue";
import * as echarts from "echarts";
import useAxios from "/src/assets/utils/http/useAxious.ts";
import { registerChart, unregisterChart } from "@/utils/chartResize";
// echart6 实例引用，供卸载时统一释放
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScreenCenterTop',
    props: {
        chartData: {
            type: Object,
            default: () => ({
                Year: [],
                Total: []
            })
        }
    },
    setup(__props) {
        let echart6Instance = null;
        // 导入组件 props
        const props = __props;
        const totalReader = ref();
        const avgBook = ref();
        // 解构 props
        const { get } = useAxios();
        const localChartData = ref({
            Year: [],
            Total: []
        });
        const fetchAvgBook = async () => {
            try {
                // 从 localStorage 获取总借书数，若不存在则默认值为 "0"
                const totalBorrowedCountStr = localStorage.getItem("totalborrowedcount") || "0";
                const totalBorrowedCount = Number(totalBorrowedCountStr);
                // 确保 totalReader.value 存在且不为 0
                if (totalReader.value && totalReader.value !== 0) {
                    avgBook.value = Math.round(totalBorrowedCount / totalReader.value);
                }
                else {
                    console.error("Invalid totalReader value. It must be a non-zero number.");
                    avgBook.value = 0;
                }
            }
            catch (error) {
                console.error("Error in fetchAvgBook", error);
            }
        };
        //totalReader
        const fetchTotalReader = async () => {
            try {
                const data = await get('/organizations/totalreadercount', {});
                if (data.ok) {
                    totalReader.value = data.msg;
                }
                else {
                    console.log("获取数据失败");
                }
            }
            catch (error) {
                console.log(error);
            }
            finally {
                initCharts();
            }
        };
        // 发送 GET 请求, 历年新增图书，取前五的年份
        const fetchData = async () => {
            try {
                const data = await get('/organizations/newbookbyyear', {});
                if (data.ok) {
                    for (let i = 0; i < 5; i++) {
                        localChartData.value.Year.push(data.msg[i].Year);
                        localChartData.value.Total.push(data.msg[i].Total);
                    }
                }
                else {
                    console.log("获取数据失败");
                }
            }
            catch (error) {
                console.log(error);
            }
            finally {
                initCharts();
            }
        };
        function initCharts() {
            const chart = echarts.init(document.getElementById('echart6'));
            echart6Instance = chart;
            chart.clear();
            chart.setOption({
                tooltip: {
                    show: true,
                    trigger: "item",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                            backgroundColor: "#7B7DDC"
                        }
                    }
                },
                legend: {
                    show: true,
                    textStyle: {
                        color: "#fff"
                    },
                    selectedMode: false,
                },
                grid: {
                    x: "8%",
                    width: "100%",
                    height: "95%",
                    left: "1%",
                    top: "5%",
                    bottom: '7%',
                    containLabel: true
                },
                xAxis: {
                    data: localChartData.value.Year,
                    axisLine: {
                        lineStyle: {
                            color: "#B4B4B4",
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: window.screen.height / 100
                    }
                },
                yAxis: [
                    {
                        splitLine: { show: false },
                        axisLine: {
                            lineStyle: {
                                color: "#B4B4B4"
                            }
                        },
                        axisLabel: {
                            fontSize: window.screen.height / 100,
                            formatter: "{value} "
                        }
                    },
                    {
                        splitLine: { show: false },
                        axisLine: {
                            lineStyle: {
                                color: "#B4B4B4"
                            }
                        },
                        axisLabel: {
                            formatter: "{value} "
                        }
                    }
                ],
                series: [
                    {
                        name: "历年新增图书数量",
                        type: "bar",
                        textStyle: {
                            color: "#fff",
                        },
                        barWidth: 20,
                        clickable: false,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 5,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    { offset: 0, color: "#e7bcf3" },
                                    { offset: 1, color: "#3EACE5" }
                                ]),
                            }
                        },
                        label: {
                            show: true,
                            position: 'top',
                            textStyle: {
                                color: '#e7bcf3',
                                fontSize: 12,
                            }
                        },
                        emphasis: {
                            focus: 'none',
                            blur: 'none'
                        },
                        data: localChartData.value.Total,
                    }
                ]
            });
            // 走全局统一 resize 管理；initCharts 会被调用多次，但同一个 chart 实例只占一个槽位
            registerChart(chart);
        }
        onMounted(async () => {
            // 先获取数据，等待两个请求完成
            await fetchData();
            await fetchTotalReader();
            // 等待 localStorage 中 "totalborrowedcount" 有数据（每 100 毫秒检测一次）
            while (!localStorage.getItem("totalborrowedcount")) {
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            // 当上面的条件满足后，再计算人均借阅量
            await fetchAvgBook();
        });
        onUnmounted(() => {
            if (echart6Instance) {
                unregisterChart(echart6Instance);
                echart6Instance.dispose();
                echart6Instance = null;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("ul", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("li", _hoisted_5, _toDisplayString(totalReader.value), 1),
                            _hoisted_6,
                            _hoisted_7
                        ])
                    ]),
                    _hoisted_8
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("ul", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("li", _hoisted_13, _toDisplayString(avgBook.value), 1),
                            _hoisted_14,
                            _hoisted_15
                        ])
                    ]),
                    _hoisted_16
                ]),
                _hoisted_17
            ], 64));
        };
    }
});
